import { ReactNode } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { SkipLink } from "@/components/ui/skip-link";

interface LayoutProps {
  children: ReactNode;
  hideFooter?: boolean;
}

const Layout = ({ children, hideFooter = false }: LayoutProps) => {
  return (
    <div className="flex min-h-screen flex-col">
      <SkipLink />
      <Header />
      <main id="main-content" className="flex-1">{children}</main>
      {!hideFooter && <Footer />}
      {/* TODO: Replace with custom AI chat widget implementation */}
    </div>
  );
};

export default Layout;
